import { taggedTemplateLiteral as _taggedTemplateLiteral, objectDestructuringEmpty as _objectDestructuringEmpty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo, useContext } from 'react';
import _Icon from '../Icon/index.js';
import _Heading from '../Heading/index.js';
import { ModalContext } from './ModalContext.js';

var _templateObject, _templateObject2;
var StyledModalHeader = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-bottom: 1px solid\n    ", ";\n  display: flex;\n  padding: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette[theme.modal.headerDividerColor];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.modal.headerPadding;
});
var StyledIcon = styled(_Icon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  top: 3px;\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var ModalHeader = function ModalHeader(_ref3) {
  _objectDestructuringEmpty(_ref3);
  var _useContext = useContext(ModalContext),
    hasCloseIcon = _useContext.hasCloseIcon,
    headerText = _useContext.headerText,
    headerComponent = _useContext.headerComponent,
    hideModal = _useContext.hideModal,
    theme = _useContext.theme;
  return /*#__PURE__*/React.createElement(StyledModalHeader, {
    theme: theme,
    className: 'modal_header'
  }, !!headerComponent ? headerComponent : headerText ? /*#__PURE__*/React.createElement(_Heading, {
    color: 'primaryDark',
    elemType: 'h1',
    elemStyle: 'h1',
    theme: theme
  }, headerText) : /*#__PURE__*/React.createElement(React.Fragment, null), hasCloseIcon && /*#__PURE__*/React.createElement(StyledIcon, {
    "aria-label": 'close modal',
    className: 'mt-0 ml-auto',
    "data-testid": 'close-icon',
    name: "close",
    onClick: hideModal,
    role: "button",
    tabIndex: 0
  }));
};
var ModalHeader$1 = /*#__PURE__*/memo(ModalHeader);

export default ModalHeader$1;
export { ModalHeader };
